export const SAVE_PURCHASE = "SAVE_PURCHASE";
export const SAVE_SUCCESS = "SAVE_SUCCESS";
